window.addEventListener('load', async function() {

    initializeSmoothScroll()

    if (window.ethereum) {
        await initialize()
    } else {
        initializeInstallInterface()
    }

});

/* Initialization */

async function initialize() {

    const web3 = new Web3(window.ethereum)
    const contract = new web3.eth.Contract(JSON.parse(wc_contract.abi), wc_contract.address)

    try {

    	window.wisher = await setUpContractState(contract)

        const accounts = await ethereum.request({ method: 'eth_accounts' })
        onAccountsChanged(accounts)

    } catch (error) {
        console.log(error)
        initializeUnavailableInterface()
    }

}

async function setUpContractState(contract) {

    var state = {
    	contract: contract,
        supply: parseInt(await contract.methods.totalSupply().call()),
        maxSupply: parseInt(await contract.methods.MAX_SUPPLY().call()),
        preSaleStart: new Date(parseInt(await contract.methods.preSaleStart().call()) * 1000),
        start: new Date(parseInt(await contract.methods.publicSaleStart().call()) * 1000),
        preSalePrice: BigNumber(await contract.methods.preSalePrice().call()),
        publicSalePrice: BigNumber(await contract.methods.publicSalePrice().call()),
        quantity: 1
    }

    return state

}

async function onAccountsChanged(accounts) {

    const now = new Date().getTime()

    if (wisher.supply >= wisher.maxSupply) {
        initializeSoldOutInterface()
    } else if (now - wisher.preSaleStart.getTime() < 0) {
    	initializeCountdownInterface()
    } else if (accounts.length == 0) {
        initializeConnectWalletInterface()
    } else if (now - wisher.start.getTime() < 0) {
        initializePresaleInterface()
    } else {
        initializeMintInterface()
    }

}

/* Countdown */

function initializeCountdownInterface() {

    // Set the date we're counting down to
    const timer = document.getElementById("timer")
    const countDownDate = wisher.preSaleStart.getTime()

    // Calculate the offset
  	var now = new Date().getTime()
  	var distance = Math.max(countDownDate - now, 0)

    // Set the initial state
    timer.innerHTML = formatDistance(distance)

    // Update the count down every 1 second
    var x = setInterval(function() {

	  var now = new Date().getTime()
	  var distance = Math.max(countDownDate - now, 0)
      timer.innerHTML = formatDistance(distance)

      if (distance <= 0) {
        clearInterval(x)
        initialize()
      }

    }, 1000);

    var heroBody = document.getElementById('wc-hero-body')
    var countdown = document.getElementById('wc-countdown')
    var active = heroBody.querySelector('.active')

    active.classList.remove('active')
    countdown.classList.add('active')

}

/* Connect */

function initializeConnectWalletInterface() {

	var heroBody = document.getElementById('wc-hero-body')
	var connect = document.getElementById('wc-connect')
	var active = heroBody.querySelector('.active')

	active.classList.remove('active')
	connect.classList.add('active')
	                    
}

function onDisclaimerCheckChanged() {

	const disclaimer = document.getElementById('wc-connect-checkbox')
	const button = document.getElementById('wc-connect-button')

	button.disabled = !disclaimer.checked

}

async function connectWallet() {

	const disclaimer = document.getElementById('wc-connect-checkbox')

	if (!disclaimer.checked) {
		return
	}

	try {
		const accounts = await ethereum.request({ method: 'eth_requestAccounts' })
        onAccountsChanged(accounts)
	} catch(error) {
		console.log(error)
	}

}

/* Presale */

function initializePresaleInterface() {

    const presale = document.getElementById('wc-presale')
    const quantityElement = presale.querySelector('#quantity')
    const totalElement = presale.querySelector('#total')
    const total = Web3.utils.fromWei(wisher.preSalePrice.multipliedBy(wisher.quantity).toString(), "ether")

    quantityElement.innerHTML = `${wisher.quantity}`
    totalElement.innerHTML = `Total: ${ total } ETH`

    var heroBody = document.getElementById('wc-hero-body')
    var active = heroBody.querySelector('.active')

    active.classList.remove('active')
    presale.classList.add('active')

}

async function requestPreSaleMint() {
  
    const mint = document.getElementById('wc-presale')
    const processing = mint.querySelector("#processing")
    const mintButton = mint.querySelector('.submit button')

    processing.classList.add('processing')
    mintButton.disabled = true

    try {

        const web3 = new Web3(window.ethereum)
        const contract = window.wisher.contract
        const accounts = await web3.eth.getAccounts()
        const account = accounts[0]
        const quantity = window.wisher.quantity
        const fee = wisher.preSalePrice.multipliedBy(quantity).toString()

        const response = await fetch(`${wc_contract.api_url}/address/${account}/proof`)
        const responseJSON = await response.json();

        if (responseJSON && responseJSON.data) {
            const proof = responseJSON.data
            const gas = await contract.methods.purchasePreSale(account, quantity, proof).estimateGas({from: account, value: fee})
            const transaction = await contract.methods.purchasePreSale(account, quantity, proof).send({ from: account, value: fee, gasLimit: gas })
            postMintSuccessMessage("Mint requested successfully")
        } else if (responseJSON.error) {
            postMintErrorMessage(responseJSON.error.message)
        }

    } catch (e) {
        const message = parseError(e)
        postMintErrorMessage(message)
    }
  
    processing.classList.remove('processing')
    mintButton.disabled = false

}

async function incrementPreSaleQuantity() {

    var updated = window.wisher.quantity + 1
    var fee = window.wisher.preSalePrice.multipliedBy(updated).toString()
    var cost = Web3.utils.fromWei(fee, "ether")

    const active = document.getElementById('wc-hero-body').querySelector('.active')
    const quantity = active.querySelector('#quantity')
    const total = active.querySelector('#total')
    quantity.innerHTML = updated
    total.innerHTML = `Total: ${cost} ETH`

    window.wisher.quantity = updated

}

async function decrementPreSaleQuantity() {

    var updated = Math.max(window.wisher.quantity - 1, 1)
    var fee = window.wisher.preSalePrice.multipliedBy(updated).toString()
    var cost = Web3.utils.fromWei(fee, "ether")

    const active = document.getElementById('wc-hero-body').querySelector('.active')
    const quantity = active.querySelector('#quantity')
    const total = active.querySelector('#total')
    quantity.innerHTML = updated
    total.innerHTML = `Total: ${cost} ETH`

    window.wisher.quantity = updated

}

/* Mint */

function initializeMintInterface() {

    const mint = document.getElementById('wc-mint')
    const quantityElement = mint.querySelector('#quantity')
    const totalElement = mint.querySelector('#total')
    const total = Web3.utils.fromWei(wisher.publicSalePrice.multipliedBy(wisher.quantity).toString(), "ether")

    quantityElement.innerHTML = `${wisher.quantity}`
    totalElement.innerHTML = `Total: ${total} ETH`

    var heroBody = document.getElementById('wc-hero-body')
    var active = heroBody.querySelector('.active')

    active.classList.remove('active')
    mint.classList.add('active')

}

async function requestMint() {
  
    const mint = document.getElementById('wc-mint')
    const processing = mint.querySelector("#processing")
    const mintButton = mint.querySelector('.submit button')

    processing.classList.add('processing')
    mintButton.disabled = true

    try {

        const web3 = new Web3(window.ethereum)
        const contract = window.wisher.contract
        const accounts = await web3.eth.getAccounts()
        const account = accounts[0]
        const quantity = window.wisher.quantity
        const fee = wisher.publicSalePrice.multipliedBy(quantity).toString()

        const gas = await contract.methods.purchase(account, quantity).estimateGas({from: account, value: fee})
        const transaction = await contract.methods.purchase(account, quantity).send({ from: account, value: fee, gasLimit: gas })
        postMintSuccessMessage("Mint requested successfully")

    } catch (e) {
        const message = parseError(e)
        postMintErrorMessage(message)
    }
  
    processing.classList.remove('processing')
    mintButton.disabled = false

}

async function incrementPublicSaleQuantity() {

    var updated = window.wisher.quantity + 1
    var fee = window.wisher.publicSalePrice.multipliedBy(updated).toString()
    var cost = Web3.utils.fromWei(fee, "ether")

    const active = document.getElementById('wc-hero-body').querySelector('.active')
    const quantity = active.querySelector('#quantity')
    const total = active.querySelector('#total')
    quantity.innerHTML = updated
    total.innerHTML = `Total: ${cost} ETH`

    window.wisher.quantity = updated

}

async function decrementPublicSaleQuantity() {

    var updated = Math.max(window.wisher.quantity - 1, 1)
    var fee = window.wisher.publicSalePrice.multipliedBy(updated).toString()
    var cost = Web3.utils.fromWei(fee, "ether")

    const active = document.getElementById('wc-hero-body').querySelector('.active')
    const quantity = active.querySelector('#quantity')
    const total = active.querySelector('#total')
    quantity.innerHTML = updated
    total.innerHTML = `Total: ${cost} ETH`

    window.wisher.quantity = updated

}

/* Mint Common */

async function postMintErrorMessage(message) {
    const active = document.getElementById('wc-hero-body').querySelector('.active')
    const alert = active.querySelector('#alert')
    alert.innerHTML = message
    alert.classList.remove('success')
    alert.classList.add('error')
}

async function postMintSuccessMessage(message) {
    const active = document.getElementById('wc-hero-body').querySelector('.active')
    const alert = active.querySelector('#alert')
    alert.innerHTML = message
    alert.classList.remove('error')
    alert.classList.add('success')
}

/* Sold Out */

function initializeSoldOutInterface() {

    var heroBody = document.getElementById('wc-hero-body')
    var soldOut = document.getElementById('wc-sold-out')
    var active = heroBody.querySelector('.active')

    active.classList.remove('active')
    soldOut.classList.add('active')

}

/* Install */

function initializeInstallInterface() {

    var heroBody = document.getElementById('wc-hero-body')
    var connect = document.getElementById('wc-install')
    var active = heroBody.querySelector('.active')

    active.classList.remove('active')
    connect.classList.add('active')

}

/* Unavailable */

function initializeUnavailableInterface() {

    var heroBody = document.getElementById('wc-hero-body')
    var connect = document.getElementById('wc-unavailable')
    var active = heroBody.querySelector('.active')

    active.classList.remove('active')
    connect.classList.add('active')

}

/* Utility */

function formatDistance(distance) {

    var days = Math.floor(distance / (1000 * 60 * 60 * 24))
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    var seconds = Math.floor((distance % (1000 * 60)) / 1000)

    return days + "d " + hours + "h " + minutes + "m " + seconds + "s "

}

function parseError(error) {


    try {
        if (error.error) {
            return parseAPIError(error)
        } else {
            return parseRPCError(error) 
        }
    } catch (e) {
        return "Unable to complete your request"
    }

}

function parseAPIError(error) {
    return error.error.message}

function parseRPCError(error) {
    var message = error.message
    message = message.substring(message.indexOf("{"))
    return JSON.parse(message).data.reason
}

/* Convenience */

function initializeSmoothScroll() {

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {

            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });

        });
    });

}